<div class="wrapper d-flex gap-4 flex-nowrap">
	@if (showMenu) {
		<nav>
			<ul class="list-unstyled components">
				@for (sideItem of sideItems; track sideItem) {
					<li
						class="sidebar-item"
						(click)="sideMenuClick(sideItem)"
						[style.background]="
							curItem == sideItem && !eventsService.isMobile
								? 'var(--light-grey)'
								: ''
						"
						[preIcon]="sideItem.icon"
						[isImg]="sideItem.isImg"
						wrapper
						d-flex
						gap-4
					>
						<div class="sidebar-item-text">
							{{ sideItem.lang | langVal }}
						</div>
					</li>
				}
			</ul>
		</nav>
	}
	@if (!eventsService.isMobile || (eventsService.isMobile && !showMenu)) {
		<div class="sections">
			<div class="d-lg-none">
				<div>
					<button
						class="close"
						tabindex="-1"
						titleLang="back_to_menu"
						(click)="showMenu = !showMenu"
						icon="modal-close"
					></button>
				</div>
				<hr />
			</div>

			@if (curItem) {
				@if (curItem.isReportsModal) {
					<app-reports [report_name]="curItem.report_name" />
				}

				@else if (curItem.intro) {
					<app-graphs-data />
        }
        @else if (!curItem.isReportsModal) {

          @switch (curItem.name) {
            @case ("expenses") {
              <app-gen-table tableName=expenses />
            }
            @case ("taxes-report") {
              <app-taxes-report />
            }
            @case ("expenses") {
              <app-taxes-report />
            }
            @case ("graphs-data") {
              <app-graphs-data />
            }
            @case ("profitloss") {
              <app-profitloss />
            }
            @case ("sub-user-patients") {
              <app-sub-user-patients />
            }
            @case ("sub-user-payments") {
              <app-sub-user-payments />
            }
            @case ("followups-for-supervisor-list") {
              <app-followups-for-supervisor-list />
            }
          }
        }
      }
		</div>
	}
</div>

